<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="center-form">
        <h2 class="center-align">{{ message }}</h2>
        <br>
        <div v-if="shouldReconnect" class="text-center">
          <c-button :onClick="onConnect" variant="transparent" :keepLoading="true">
            <img class="logo" src="../../public/connect-with-strava.png" width="200px">
          </c-button>
        </div>
        <div v-else-if="!shouldReconnect && !promptEmail">
          <fa-icon icon="spinner" spin />
        </div>
        <b-form v-else-if="!shouldReconnect && promptEmail">
          <b-form-group id="email" label="Email address" label-for="email">
            <b-form-input
              id="email"
              v-model="form.email.value"
              :state="form.email.error.state"
              type="email"
              placeholder="Enter your email address"
              required
            ></b-form-input>
            <b-form-invalid-feedback :state="form.email.error.state">
              {{ form.email.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>

          <c-button :onClick="onNext" variant="primary" class="right-align">Next</c-button>
          <br><br>
          <span class="success right-align">{{ formSuccess }}</span>
          <span class="failure right-align">{{ formFailure }}</span>
        </b-form>
        <br>
        <span class="failure">{{ failureMessage }}</span>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import { onLogin } from '../vue-apollo';
  import CButton from '@/components/Button'

  export default {
    name: 'Authorize',
    components: { CButton },
    props: {

    },
    data() {
      return {
        code: null,
        scope: null,
        message: '',
        failureMessage: '',
        shouldReconnect: true,
        promptEmail: false,
        formSuccess: '',
        formFailure: '',
        form: {
          email: {
            value: '',
            error: {}
          },
        },
      }
    },
    async created() {
      if (this.user && this.user.email) this.$router.push({ name: 'Home' });
      if (this.$route.query.error) {
        const error = this.$route.query.error
        if (error === 'access_denied') {
          this.message = 'You did not authorize Strava to connect to your account. Please try again'
        } else {
          this.message = 'There has been an error connecting to Strava. Please try again'
        }
      } else if (this.$route.query.code && this.$route.query.scope) {
        this.code = this.$route.query.code
        this.scope = this.$route.query.scope
        if (this.scope !== 'read,activity:write,activity:read_all' && this.scope !== 'activity:read_all,activity:write,read') {
          this.message = 'You did not give the right permissions. Please select all permissions. Try again'
        } else if (!this.code) {
          this.message = 'There has been an error connecting to Strava. Please try again'
        } else {
          this.shouldReconnect = false
          await this.exchangeToken()
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
      isMobile() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      }
    },
    methods: {
      async onConnect(event) {
        this.failureMessage = ''

        try {
          const response = await this.$http.get(process.env.VUE_APP_API_BASE_URL + "/auth")

          if (response && response.body && response.body.authUrlWeb) {
            if (this.isMobile) {
              window.location.href = response.body.authUrlMobile;
            } else {
              window.location.href = response.body.authUrlWeb;
            }
          } else {
            throw(new Error('Could not redirect to Strava log in page'))
          }
        } catch(e) {
          this.failureMessage = e
        }
      },
      async exchangeToken() {
        this.message = 'Authorizing...'

        try {
          const body = {
            code: this.code,
            scope: this.scope
          }
          const response = await this.$http.post(process.env.VUE_APP_API_BASE_URL + "/auth", body)

          await onLogin.apply(this, [this.$apollo.provider.defaultClient, response.body.user])

          if (!this.user.email) {
            this.promptEmail = true
            this.message = 'Please enter your email address'
          } else {
            this.$router.push({ name: 'Home' });
          }
        } catch(e) {
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }
      },
      async onNext(event) {
        this.failureMessage = ''
        this.formSuccess = ''
        this.formFailure = ''
        for (let key in this.form) {
          this.form[key].error = {}
        }

        try {
          const body = {
            email: this.form.email.value,
            userId: this.user.id
          }
          const response = await this.$http.post(process.env.VUE_APP_API_BASE_URL + "/user", body)

          await onLogin.apply(this, [this.$apollo.provider.defaultClient, response.body.user])
          this.$router.push({ name: 'Home' });
        } catch(e) {
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
            if (e.body.details) {
              e.body.details.map(detail => {
                detail.path.map(path => {
                  this.$set(this.form[path], 'error', {state: false, value: detail.message})
                })
              })
            }
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
